'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var dls = [];

var pushDL = function pushDL(dl) {
  if (typeof window === 'undefined' || typeof window.dataLayer === 'undefined') {
    return;
  }

  window.dataLayer.push(dl);
};

var queueDataLayer = function queueDataLayer(dataLayer) {
  return dls.push(dataLayer);
};

var pushDataLayer = function pushDataLayer(dataLayer) {
  return pushDL(dataLayer);
};

var pushPageLoadDataLayer = function pushPageLoadDataLayer() {
  var eventName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'DOM SPA Ready';
  pushDL({
    event: eventName
  });
};

var flush = function flush() {
  dls.map(pushDL);
  dls = [];
};

exports.queueDataLayer = queueDataLayer;
exports.pushDataLayer = pushDataLayer;
exports.pushPageLoadDataLayer = pushPageLoadDataLayer;
exports.flush = flush;